
import { Component, Prop, Vue } from "vue-property-decorator";
import { Company, User } from "@/generated/graphql";
import BaseSidebar from "@/components/sidebar/BaseSidebar.vue";
import SidebarItem from "@/components/sidebar/Sidebartem.vue";
import Tooltip from "@/components/common/Tooltip.vue";
import UiButton from "@/components/button/ui-button.vue";
import REQUEST_MARKETPLACE_ACCESS from "@/apollo/marketplace/RequestMarketplaceAccess.gql";
import CANCEL_REQUEST_TO_MARKETPLACE_ACCESS from "@/apollo/marketplace/CancelRequestToMarketplaceAccess.gql";
import TooltipVariants from "@/entities/TooltipVariants";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import { ISidebarNavDataChild } from "@/data/sidebar";

interface MarketplaceRequestOptions {
  buttonText: string,
  action: any,
}

@Component({
  components: {
    UiButton,
    Tooltip,
    BaseSidebar,
    SidebarItem,
  },
})
export default class OptionalMarketplace extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly sidebarItem!: ISidebarNavDataChild;
  @Prop({ type: Object, required: true }) readonly company!: Company;

  TooltipVariants = TooltipVariants;
  processing: boolean = false;
  requested: boolean = false;

  get marketplaceRequestOptions(): MarketplaceRequestOptions {
    if (this.isRequested) {
      return {
        buttonText: "Cancel request",
        action: () => this.confirmCancelRequest(() => this.changeMarketplaceRequestState(this._cancelRequest)),
      };
    }

    return {
      buttonText: "Request access",
      action: () => this.changeMarketplaceRequestState(this._requestAccess),
    };
  }

  get marketPlaceAccessRequested(): boolean {
    return this.currentUser.manager!.marketplace_access_requested;
  }

  get isRequested(): boolean {
    return this.marketPlaceAccessRequested || this.requested;
  }

  async changeMarketplaceRequestState(changeRequestState: () => any): Promise<void> {
    if (this.processing) {
      return;
    }

    this.processing = true;

    try {
      await changeRequestState();
    } catch (error) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage("Something went wrong!"));
    } finally {
      this.processing = false;
    }
  }

  confirmCancelRequest(action: () => Promise<void>): any {
    this.$confirm({
      title: "Cancel request",
      message: `Do you want to cancel your request to the public Marketplace`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
          await action();
        }
      },
    });
  }

  private async _requestAccess() {
    await this.$apollo.mutate({
      mutation: REQUEST_MARKETPLACE_ACCESS,
      variables: {
        managerId: this.currentUser.manager!.id,
      },
    });
    this.requested = true;
    this.$eventBus.emit(NOTIFICATION, Message.successMessage("You have requested access to the public Marketplace"));
  }

  private async _cancelRequest() {
    await this.$apollo.mutate({
      mutation: CANCEL_REQUEST_TO_MARKETPLACE_ACCESS,
      variables: {
        managerId: this.currentUser.manager!.id,
      },
    });
    this.requested = false;
    this.$eventBus.emit(NOTIFICATION, Message.successMessage("You have canceled your request to the public Marketplace"));
  }
}
